import React from "react";
import {
  TrendingUp,
  Coins,
  Gem,
  Blocks,
} from "lucide-react";
import "./Home.css";
// =========================================================
// =========================================================
// MINI CANDLESTICK GRAPH
// =========================================================

const MiniCandleGraph = ({ value, variant = "default" }) => {
  const numericValue = Number(value) || 100;

  const candles = [
    { o: 0.94, c: 0.97, h: 1.00, l: 0.91 },
    { o: 0.97, c: 0.95, h: 1.01, l: 0.93 },
    { o: 0.95, c: 0.99, h: 1.02, l: 0.94 },
    { o: 0.99, c: 1.03, h: 1.06, l: 0.97 },
    { o: 1.03, c: 1.01, h: 1.07, l: 0.99 },
    { o: 1.01, c: 1.06, h: 1.09, l: 1.00 },
    { o: 1.06, c: 1.04, h: 1.10, l: 1.02 },
    { o: 1.04, c: 1.09, h: 1.12, l: 1.03 },
    { o: 1.09, c: 1.07, h: 1.13, l: 1.05 },
    { o: 1.07, c: 1.12, h: 1.15, l: 1.06 },
  ];

  const minValue = numericValue * 0.90;
  const maxValue = numericValue * 1.17;
  const range = maxValue - minValue || 1;

  const getY = (multiplier) => {
    return 42 - ((numericValue * multiplier - minValue) / range) * 34;
  };

  return (
    <div className={`candle-chart candle-chart-${variant}`}>
      <svg
        viewBox="0 0 120 46"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        {candles.map((candle, index) => {
          const x = 7 + index * 12;

          const openY = getY(candle.o);
          const closeY = getY(candle.c);
          const highY = getY(candle.h);
          const lowY = getY(candle.l);

          const isUp = candle.c >= candle.o;

          const bodyTop = Math.min(openY, closeY);
          const bodyHeight = Math.max(
            Math.abs(closeY - openY),
            2
          );

          return (
            <g key={index}>
              {/* Wick */}
              <line
                x1={x}
                y1={highY}
                x2={x}
                y2={lowY}
                className={
                  isUp
                    ? "candle-wick-up"
                    : "candle-wick-down"
                }
              />

              {/* Candle body */}
              <rect
                x={x - 2.5}
                y={bodyTop}
                width="5"
                height={bodyHeight}
                rx="1"
                className={
                  isUp
                    ? "candle-body-up"
                    : "candle-body-down"
                }
              />
            </g>
          );
        })}
      </svg>
    </div>
  );
};

// =========================================================
// MARKET STATS COMPONENT
// =========================================================

const MarketStats = ({
  baitPrice = 0,
  marketCap = 0,
  circulatingSupply = 0,
  blockNumber = 0,
  goldPerGram = 0,
  goldPerOz = 0,
  formatUSD,
  formatNumber,
  formatPrice,
}) => {
  return (
   <div className="market-stats-grid">

  {/* =================================================
      MARKET CAP
  ================================================= */}

  <div className="market-stat-card">

    <div className="market-stat-top">


    </div>

    <div className="market-stat-content">

     
      <strong>
        {formatUSD
          ? formatUSD(marketCap)
          : "$0.00"}
      </strong>

    </div>

  

  </div>


  {/* =================================================
      CIRCULATING SUPPLY
  ================================================= */}

  <div className="market-stat-card">

    <div className="market-stat-top">

 

    </div>

    <div className="market-stat-content">

      

      <strong>
        {formatNumber
          ? `${formatNumber(circulatingSupply)} BAIT`
          : `${Number(circulatingSupply).toLocaleString()} BAIT`}
      </strong>

    </div>

 

  </div>


  {/* =================================================
      CURRENT BLOCK
  ================================================= */}

  <div className="market-stat-card">

    <div className="market-stat-top">

      

    </div>

    <div className="market-stat-content">

      

      <strong>
        #
        {formatNumber
          ? formatNumber(blockNumber)
          : Number(blockNumber).toLocaleString()}
      </strong>

    </div>

   

  </div>


  {/* =================================================
      GOLD PRICE
  ================================================= */}

  <div className="market-stat-card">

    <div className="market-stat-top">

      

    </div>

    <div className="market-stat-content">
 
  <strong>{formatPrice(baitPrice)}</strong>
</div>
 
 

  </div>

</div>
  );
};

export default MarketStats;